const displayFunction = data => {
  let lengthValue = '';
  if (data.length && !isNaN(data.length)) {
    lengthValue = data.length.toFixed(2) + ' mm';
  }
  return lengthValue;
};

export const height = {
  id: 'Height',
  name: 'Height',
  toolGroup: 'allTools',
  cornerstoneToolType: 'Height',
  options: {
    measurementTable: {
      displayFunction,
    },
    caseProgress: {
      include: true,
      evaluate: true,
    },
  },
};
